import * as React from 'react'
import { useId } from 'react'

import { computeSize } from '../shared'
import type { IconProps } from '../shared'

type RepostIconProps = IconProps & {
  color?: string
}

/**
 * Threads repost icon with complex SVG content (clipPath, defs).
 */
const RepostIcon = React.forwardRef<SVGSVGElement, RepostIconProps>(
  ({ size = 'small', className, color = 'currentColor', ...props }, ref) => {
    const computedSize = computeSize(size)
    const clipPathId = useId()

    return (
      <svg
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden="true"
        width={computedSize}
        height={computedSize}
        ref={ref}
        {...props}
      >
        <g clipPath={`url(#${clipPathId})`}>
          <path
            d="M6.41257 1.23513C6.63491 0.971094 7.02918 0.937298 7.29321 1.15964L9.96509 3.40964C10.1022 3.5251 10.1831 3.69386 10.1873 3.87306C10.1915 4.05225 10.1186 4.22462 9.98706 4.34638L7.31518 6.81953C7.06186 7.05401 6.66643 7.03874 6.43196 6.78542C6.19748 6.5321 6.21275 6.13667 6.46607 5.90219L7.96721 4.51271H5.20312C3.68435 4.51271 2.45312 5.74393 2.45312 7.26271V11.7627C2.45312 13.2815 3.68435 14.5127 5.20312 14.5127C5.54831 14.5127 5.82812 14.7925 5.82812 15.1377C5.82812 15.4829 5.54831 15.7627 5.20312 15.7627C2.99399 15.7627 1.20312 13.9718 1.20312 11.7627V7.26271C1.20312 5.05357 2.99399 3.26271 5.20312 3.26271H7.85003L6.48804 2.11578C6.22401 1.89344 6.19022 1.49916 6.41257 1.23513Z"
            fill={color}
          />
          <path
            d="M11.5874 17.7902C11.3651 18.0543 10.9708 18.0881 10.7068 17.8657L8.03491 15.6157C7.89781 15.5003 7.81687 15.3315 7.81267 15.1523C7.80848 14.9731 7.88141 14.8008 8.01295 14.679L10.6848 12.2058C10.9381 11.9714 11.3336 11.9866 11.568 12.24C11.8025 12.4933 11.7872 12.8887 11.5339 13.1232L10.0328 14.5127H12.7969C14.3157 14.5127 15.5469 13.2814 15.5469 11.7627V7.26268C15.5469 5.7439 14.3157 4.51268 12.7969 4.51268C12.4517 4.51268 12.1719 4.23286 12.1719 3.88768C12.1719 3.54251 12.4517 3.26268 12.7969 3.26268C15.006 3.26268 16.7969 5.05355 16.7969 7.26268V11.7627C16.7969 13.9718 15.006 15.7627 12.7969 15.7627H10.15L11.512 16.9096C11.776 17.1319 11.8098 17.5262 11.5874 17.7902Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id={clipPathId}>
            <rect width="18" height="18" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )
  },
)

RepostIcon.displayName = 'ThreadsRepostIcon'

export { RepostIcon }
